/** Shared DOM ownership for player shortcuts, seeking and controller focus. */
export const inputVisible = (element: HTMLElement) => element.isConnected
  && element.getBoundingClientRect().width > 0 && element.getBoundingClientRect().height > 0
  && !element.closest('[inert],[aria-hidden=true]') && getComputedStyle(element).visibility !== 'hidden';
export const topInputDialog = () => [...document.querySelectorAll<HTMLElement>('[role=dialog],[role=alertdialog]')].filter(inputVisible).at(-1);
export function ownsInputTarget(scope: HTMLElement | null, target: Element) {
  const dialog = topInputDialog();
  return !!scope?.contains(target) && (!dialog || dialog === scope || dialog.contains(scope));
}
/** Modal focus transfer may finish after the opening render. Native video
 * controls must not consume an already-held media key during that interval. */
export function coveredMediaKey(scope: HTMLElement | null, event: KeyboardEvent) {
  return event.target instanceof HTMLMediaElement && !!scope?.contains(event.target)
    && !ownsInputTarget(scope, event.target) && !event.altKey && !event.ctrlKey && !event.metaKey
    && [' ', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'MediaFastForward', 'MediaRewind'].includes(event.key);
}
